import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // }
    {
      path: "/",
      redirect: "/Shouye" //设置默认指向
    },
    {
      path: "/Shouye",
      component: () => import("@/views/shouye/index"),
      name: "Shouye"
    },
    {
      path: "/Home",
      component: () => import("@/views/home/index"),
      name: "Home"
    },
    {
      path: "/Center",
      component: () => import("@/views/center/index"),
      name: "Center"
    },
    {
      path: "/Demo",
      component: () => import("@/views/demo/demo"),
      name: "Demo"
    }
  ]
});




// WEBPACK FOOTER //
// ./src/router/index.js